import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import logo from "../assest/products/extra/logo.jpeg"; 

const socialLinks = [
  {
    icon: FaFacebookF,
    link: "https://www.facebook.com/profile.php?id=61586673347110",
    color: "hover:bg-blue-600"
  },
  // {
  //   icon: FaTwitter,
  //   link: "https://twitter.com",
  //   color: "hover:bg-sky-500"
  // },
  // {
  //   icon: FaInstagram,
  //   link: "https://instagram.com",
  //   color: "hover:bg-pink-500"
  // },
  {
    icon: FaLinkedinIn,
    link: "Hey come check out and follow my page! https://www.linkedin.com/company/lappyshop-com/",
    color: "hover:bg-blue-700"
  },
  // {
  //   icon: FaYoutube,
  //   link: "https://youtube.com",
  //   color: "hover:bg-red-600"
  // }
];
const Footer = () => {
  return (
    <footer className="bg-[#0f172a] text-gray-300 pt-12">

      <div className="max-w-7xl mx-auto px-6">

        {/* 🔥 TOP */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10">

          {/* LOGO */}
          <div className="col-span-2 lg:col-span-1">
            <img src={logo} alt="LappyShop" className="h-10 mb-4" />

            <p className="text-sm text-gray-400 leading-relaxed">
              India's trusted refurbished laptop store providing
              cost-effective IT solutions for individuals & businesses.
            </p>
          </div>

          {/* ABOUT */}
          <div>
            <h3 className="text-white font-semibold mb-4">
              About
            </h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contact" className="hover:text-white">About LappyShop</Link></li>
              <li><Link to="/contact" className="hover:text-white">Our Story</Link></li>
              <li><Link to="/contact" className="hover:text-white">Refurbishing Process</Link></li>
            </ul>
          </div>

          {/* PRODUCTS */}
          <div>
            <h3 className="text-white font-semibold mb-4">
              Products
            </h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/product-category?category=laptops">Laptops</Link></li>
              <li><Link to="/product-category?category=ultrabook">Ultrabook</Link></li>
              <li><Link to="/product-category?category=mini-pc">Mini PC</Link></li>
              <li><Link to="/product-category?category=monitor">Monitors</Link></li>
            </ul>
          </div>

          {/* HELP */}
          <div>
            <h3 className="text-white font-semibold mb-4">
              Help
            </h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/contact">Contact Us</Link></li>
              <li><Link to="/terms">Terms of Service</Link></li>
              <li><Link to="/return-policy">Return Policy</Link></li>
              <li><Link to="/privacy-policy">Privacy Policy</Link></li>
            </ul>
          </div>

          {/* CONTACT */}
          <div>
            <h3 className="text-white font-semibold mb-4">
              Contact
            </h3>

            <p className="text-sm mb-2">
              📞{" "}
              <a href="tel:+918700074576" className="hover:text-white">
                +91-8700074576
              </a>
            </p>

            <p className="text-sm mb-2">
              📧{" "}
              <a
                href="mailto:support@lappyshop.com"
                className="hover:text-white"
              >
                support@lappyshop.com
              </a>
            </p>

            <p className="text-sm">
              📦 Bulk:{" "}
              <a href="tel:+919560205329" className="hover:text-white">
                +91-9560205329
              </a>
            </p>

          </div>

        </div>

        {/* 🔥 NEWSLETTER */}
        <div className="border-t border-gray-700 mt-10 pt-8 flex flex-col md:flex-row justify-between items-center gap-6">

          <div className="text-white font-medium">
            Subscribe for latest deals 🚀
          </div>

          <div className="flex items-center bg-[#1e293b] rounded-full px-4 py-2 w-full md:w-[350px]">

            <FiMail className="text-gray-400 mr-3" />

            <input
              type="email"
              placeholder="Enter email"
              className="bg-transparent outline-none text-sm flex-1 text-white"
            />

            <button className="bg-blue-500 hover:bg-blue-600 text-white rounded-full w-8 h-8 flex items-center justify-center transition">
              →
            </button>

          </div>

          {/* SOCIAL */}

<div className="flex gap-4 text-white text-lg">

  {socialLinks.map((item, i) => {
    const Icon = item.icon;

    return (
      <a
        key={i}
        href={item.link}
        target="_blank"
        rel="noreferrer"
        className={`bg-[#1e293b] p-3 rounded-full transition duration-300 transform hover:scale-110 ${item.color}`}
      >
        <Icon />
      </a>
    );
  })}

</div>

        </div>

        {/* 🔥 BOTTOM */}
        <div className="border-t border-gray-700 mt-8 py-6 text-sm text-gray-400 text-center">

          © 2026 LappyShop. All rights reserved.

        </div>

      </div>

    </footer>
  );
};

export default Footer;